<template lang="pug">
  .splash-container
    .splash
      img(:class="`splashes${frame%15+1}`" alt="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAR8AAAEMAQMAAADH2yA7AAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAACBJREFUeNrtwTEBAAAAwqD1T20LL6AAAAAAAAAAAADgaya8AAEsh/45AAAAAElFTkSuQmCC")
</template>

<script>
  import Raf from 'src/helpers/Raf'
  import { mapState, mapMutations } from 'vuex'
  export default {
    name: "Splash",
    props:{
      progress: {
        default: 0
      }
    },
    data(){
      return {
        frame: 1,
        frameRate: 1000/10,
        interval: null
      }
    },
    computed:{

      //frame(){
      //  return Math.floor(this.progress*30)%15+1
      //}
    },
    mounted(){
      this.interval = setInterval(this.update, this.frameRate)
    },
    methods:{
      update(){
        this.frame++
      }
    },
    beforeDestroy(){
      clearInterval(this.interval)
    }
  }
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.splash-container
  +full()
  display: flex
  align-items: center
  justify-content: center
  //background: #e15125
  .splash
    width: 3rem
    margin-left: 0.1rem
    //background: #e15125
    img
      //width: 100%
      display: block
    .splashes1, .splashes10, .splashes11, .splashes12, .splashes13,
    .splashes14, .splashes15, .splashes2, .splashes3, .splashes4,
    .splashes5, .splashes6, .splashes7, .splashes8, .splashes9
      max-width: 100%
      background-size: 100%
      background-image: url('~assets/tutorial/splash.png')

    .splashes1
      background-position: 0 0%
      background-size: 100%
    .splashes10
      background-position: 0 7.142857%
      background-size: 100%
    .splashes11
      background-position: 0 14.285714%
      background-size: 100%
    .splashes12
      background-position: 0 21.428571%
      background-size: 100%
    .splashes13
      background-position: 0 28.571429%
      background-size: 100%
    .splashes14
      background-position: 0 35.714286%
      background-size: 100%
    .splashes15
      background-position: 0 42.857143%
      background-size: 100%
    .splashes2
      background-position: 0 50%
      background-size: 100%
    .splashes3
      background-position: 0 57.142857%
      background-size: 100%
    .splashes4
      background-position: 0 64.285714%
      background-size: 100%
    .splashes5
      background-position: 0 71.428571%
      background-size: 100%
    .splashes6
      background-position: 0 78.571429%
      background-size: 100%
    .splashes7
      background-position: 0 85.714286%
      background-size: 100%
    .splashes8
      background-position: 0 92.857143%
      background-size: 100%
    .splashes9
      background-position: 0 100%
      background-size: 100%
</style>